import { render, staticRenderFns } from "./AddressForm.vue?vue&type=template&id=ddc90f98&scoped=true"
import script from "./AddressForm.vue?vue&type=script&lang=js"
export * from "./AddressForm.vue?vue&type=script&lang=js"
import style0 from "./AddressForm.vue?vue&type=style&index=0&id=ddc90f98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc90f98",
  null
  
)

export default component.exports